import { safeParseFloat } from '@/core/lib/utils/parse-float'
import { envService } from '@/core/services/env'
import { CountryResponse } from '../types/api-responses/country-response'
import { CountryModel } from '../types/models/country.model'

// The API is inconsistent across environments: some return the flag as an
// absolute URL (https://host/vendor/...svg) while others return a host-relative
// path (/vendor/...svg). A relative path would resolve against the frontend
// origin (where it doesn't exist) and 404, so normalize it to an absolute URL
// using the API origin.
function resolveFlagUrl(flag: string): string {
  if (!flag || /^https?:\/\//i.test(flag)) return flag
  try {
    const apiOrigin = new URL(envService.get('BASE_URL')).origin
    return new URL(flag, apiOrigin).href
  } catch {
    return flag
  }
}

export function countryResolver(country: CountryResponse): CountryModel
export function countryResolver(country: CountryResponse[]): CountryModel[]

export function countryResolver(
  country: CountryResponse | CountryResponse[],
): CountryModel | CountryModel[] {
  if (Array.isArray(country)) {
    return country.map(resolveCountry)
  }
  return resolveCountry(country)
}

function resolveCountry(country: CountryResponse): CountryModel {
  return {
    id: country.id,
    flag: resolveFlagUrl(country.country_flag),
    name: country.name,
    latitude: safeParseFloat(country.latitude),
    longitude: safeParseFloat(country.longitude),
  }
}
